<template>
  <div class="inventory">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="saveClient" class="btn fixed_btn">Save Client</button>
      <div class="card">
        <div class="inputs">
          <div class="input">
            <label>Company</label>
            <input v-model="client.company_name" />
          </div>

          <div class="input">
            <label>Title</label>
            <input v-model="client.title" />
          </div>

          <div class="input">
            <label>First Name</label>
            <input v-model="client.first_name" />
          </div>
          <div class="input">
            <label>Last Name</label>
            <input v-model="client.last_name" />
          </div>
          <div class="input">
            <label>Email</label>
            <input v-model="client.email" />
          </div>
          <div class="input">
            <label>Phone Number</label>
            <input v-mask="['(###) ###-####']" v-model="client.phone" />
          </div>

          <g-address
            :inputAddress="client.address"
            @autoCompleteAddress="autoCompleteAddress"
          />
        </div>
      </div>

      <div class="cards">
        <div class="card">
          <div class="inputs">
            <div class="input">
              <label>Primary Contact</label>
              <toggle-button
                :value="true"
                color="#82C7EB"
                :sync="true"
                :labels="true"
                v-model="contact.primary"
              />
            </div>
            <div class="input full">
              <label>Contact Name</label>
              <input v-model="contact.name" />
            </div>
            <div class="input full">
              <label>Contact Email</label>
              <input v-model="contact.email" />
            </div>
            <div class="input full">
              <label>Contact Phone</label>
              <input v-model="contact.phone" />
            </div>
            <div class="btns right">
              <button @click="addContact()" class="btn round-btn">
                Add Contact
              </button>
            </div>
          </div>
        </div>
        <div class="card" v-for="(cContact, i) in client.contacts" :key="i">
          <div class="inputs">
            <div class="input full">
              <label>Contact Name</label>
              <input v-model="cContact.name" />
            </div>
            <div class="input full">
              <label>Contact Email</label>
              <input v-model="cContact.email" />
            </div>
            <div class="input full">
              <label>Contact Phone</label>
              <input v-model="cContact.phone" />
            </div>
            <div class="input full delete-btn">
              <p @click="deleteContact(i)" class="delete">x</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Register from "@/components/Register";
import firebase from "firebase";
import Swal from "sweetalert2";
import GoogleAddress from "@/components/GoogleAddress.vue";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;

export default {
  name: "loginregister",
  components: {
    register: Register,
    "g-address": GoogleAddress,
  },
  data() {
    return {
      user: this.$store.state.reseller,
      contact: {
        name: null,
        email: null,
        phone: null,
      },
      client: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        company_name: null,
        title: null,
        address: {
          address_1: null,
          address_2: null,
          address_3: null,
          city: null,
          state: null,
          zip: null,
          country: "United States",
        },
        contacts: [],
        units: [],
      },
    };
  },
  created() {
    this.$bind(
      "client",
      db
        .collection(`reseller_profile/${this.user.id}/clients`)
        .doc(this.$route.params.id)
    ).then((client) => {
      if (!client) {
        this.client = {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          company_name: null,
          title: null,
          address: {
            address_1: null,
            address_2: null,
            address_3: null,
            city: null,
            state: null,
            zip: null,
            country: null,
          },
          contacts: [],
          units: [],
        };
      }
    });
  },
  computed: {
    validate() {
      let valid = true;
      let client = this.client;

      for (let key in client) {
        if (!client[key]) {
          valid = false;
        }
      }
      for (let key in client.address) {
        if (!client.address[key]) {
          if (key != 'address_2' && key != 'address_3' && key != 'units') {
            console.log(key)
            valid = false;
          }
        }
      }

      return valid;
    },
  },
  methods: {
    autoCompleteAddress(payload) {
      this.client.address = payload;
    },
    validateClient(){
      let valid = true
      if (!this.contact.name) valid = false;
      if (!this.contact.email && !this.contact.phone) valid = false;
      return valid;
    },  
    addContact() {
      if (this.validateClient()) {
        this.client.contacts.push(this.contact);
        this.contact = {
          primary: false,
          name: null,
          email: null,
          phone: null,
        };
      }else {
        Swal.fire("Please fill a name and or phone / email")
      }
    },
    deleteContact(index) {
      this.client.contacts.splice(index, 1);
    },
    saveClient() {
      if (this.validate) {
        let client_ref = db
          .collection(`reseller_profile/${this.user.id}/clients`)
          .doc(this.$route.params.id);
        client_ref.set(this.client, { merge: true }).then(() => {
          Swal.fire("Client has been saved").then(() =>
            this.$router.push("/clients")
          );
        });
      }else {
        Swal.fire("Please fill in all fields")
      }
    },
  },
};
</script>

<style lang="scss">
.totals {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 20px 0;
  p {
    margin-left: 40px;
    font-size: 15px;
    span {
      font-size: 35px;
      font-weight: bold;
      font-family: "SFProDisplay", sans-serif;
      display: block;
    }
  }
}
</style>
